function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach(summary => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', 'false');

  if (summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', event => {
    event.currentTarget.setAttribute(
      'aria-expanded',
      !event.currentTarget.closest('details').hasAttribute('open')
    );
  });

  if (summary.closest('header-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = event => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(':focus-visible');
} catch {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    'ARROWUP',
    'ARROWDOWN',
    'ARROWLEFT',
    'ARROWRIGHT',
    'TAB',
    'ENTER',
    'SPACE',
    'ESCAPE',
    'HOME',
    'END',
    'PAGEUP',
    'PAGEDOWN'
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', event => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', event => {
    mouseClick = true;
  });

  window.addEventListener(
    'focus',
    () => {
      if (currentFocusedElement)
        currentFocusedElement.classList.remove('focused');

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add('focused');
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach(video => {
    video.contentWindow.postMessage(
      '{"event":"command","func":"' + 'pauseVideo' + '","args":""}',
      '*'
    );
  });
  document.querySelectorAll('.js-vimeo').forEach(video => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach(video => video.pause());
  document.querySelectorAll('product-model').forEach(model => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });

    this.querySelectorAll('button').forEach(button =>
      button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value)
      this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: `application/${type}`
    }
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement('form');
  form.setAttribute('method', method);
  form.setAttribute('action', path);

  for (var key in params) {
    var hiddenField = document.createElement('input');
    hiddenField.setAttribute('type', 'hidden');
    hiddenField.setAttribute('name', key);
    hiddenField.setAttribute('value', params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (
  country_domid,
  province_domid,
  options
) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(
    options['hideElement'] || province_domid
  );

  Shopify.addListener(
    this.countryEl,
    'change',
    Shopify.bind(this.countryHandler, this)
  );

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = '';
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    if (navigator.platform === 'iPhone')
      document.documentElement.style.setProperty(
        '--viewport-height',
        `${window.innerHeight}px`
      );

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach(summary =>
      summary.addEventListener('click', this.onSummaryClick.bind(this))
    );
    this.querySelectorAll('button').forEach(button =>
      button.addEventListener('click', this.onCloseButtonClick.bind(this))
    );
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(
          event,
          this.mainDetailsToggle.querySelector('summary')
        )
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function addTrapFocus() {
      trapFocus(
        summaryElement.nextElementSibling,
        detailsElement.querySelector('button')
      );
      summaryElement.nextElementSibling.removeEventListener(
        'transitionend',
        addTrapFocus
      );
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen
        ? this.closeMenuDrawer(event, summaryElement)
        : this.openMenuDrawer(summaryElement);
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener(
              'transitionend',
              addTrapFocus
            );
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event !== undefined) {
      this.mainDetailsToggle.classList.remove('menu-opening');
      this.mainDetailsToggle.querySelectorAll('details').forEach(details => {
        details.removeAttribute('open');
        details.classList.remove('menu-opening');
      });
      document.body.classList.remove(
        `overflow-hidden-${this.dataset.breakpoint}`
      );
      removeTrapFocus(elementToFocus);
      this.closeAnimation(this.mainDetailsToggle);
    }
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (
        this.mainDetailsToggle.hasAttribute('open') &&
        !this.mainDetailsToggle.contains(document.activeElement)
      )
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    detailsElement.classList.remove('menu-opening');
    detailsElement
      .querySelector('summary')
      .setAttribute('aria-expanded', false);
    removeTrapFocus();
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = time => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(
            detailsElement.closest('details[open]'),
            detailsElement.querySelector('summary')
          );
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header =
      this.header || document.getElementById('shopify-section-moynat-header');
    this.borderOffset =
      this.borderOffset ||
      this.closest('.header-wrapper').classList.contains(
        'header-wrapper--border-bottom'
      )
        ? 1
        : 0;
    document.documentElement.style.setProperty(
      '--header-bottom-position',
      `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
    );

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this)
    );
    this.addEventListener('keyup', event => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', event => {
        if (
          event.pointerType === 'mouse' &&
          !event.target.closest('deferred-media, product-model')
        )
          this.hide();
      });
    } else {
      this.addEventListener('click', event => {
        if (event.target.nodeName === 'MODAL-DIALOG') this.hide();
      });
    }
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent() {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(
        this.querySelector('template').content.firstElementChild.cloneNode(true)
      );

      this.setAttribute('loaded', true);
      this.appendChild(
        content.querySelector('video, model-viewer, iframe')
      ).focus();
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('ul');
    this.sliderItems = this.querySelectorAll('li');
    this.pageCount = this.querySelector('.slider-counter--current');
    this.pageTotal = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    const resizeObserver = new ResizeObserver(entries => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    const sliderItemsToShow = Array.from(this.sliderItems).filter(
      element => element.clientWidth > 0
    );
    this.sliderLastItem = sliderItemsToShow[sliderItemsToShow.length - 1];
    if (sliderItemsToShow.length === 0) return;
    this.slidesPerPage = Math.floor(
      this.slider.clientWidth / sliderItemsToShow[0].clientWidth
    );
    this.totalPages = sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  update() {
    if (!this.pageCount || !this.pageTotal) return;
    this.currentPage =
      Math.round(this.slider.scrollLeft / this.sliderLastItem.clientWidth) + 1;

    const currentPosition = Math.round(
      this.slider.scrollWidth - this.slider.scrollLeft
    );

    if (!this.slider.classList.contains('no-disable')) {
      if (this.slider.scrollLeft == 0) {
        this.prevButton.setAttribute('disabled', 'disabled');
      } else {
        this.prevButton.removeAttribute('disabled');
      }

      if (currentPosition == this.slider.clientWidth) {
        this.nextButton.setAttribute('disabled', 'disabled');
      } else {
        this.nextButton.removeAttribute('disabled');
      }
    }

    this.pageCount.textContent = this.currentPage;
    this.pageTotal.textContent = this.totalPages;
  }

  onButtonClick(event) {
    event.preventDefault();
    const slideScrollPosition =
      event.currentTarget.name === 'next'
        ? this.slider.scrollLeft + this.sliderLastItem.clientWidth
        : this.slider.scrollLeft - this.sliderLastItem.clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SliderThumbnails extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('ul');
    this.sliderItems = this.querySelectorAll('li');
    this.pageCount = this.querySelector('.slider-counter--current');
    this.pageTotal = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    const resizeObserver = new ResizeObserver(entries => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    const sliderItemsToShow = Array.from(this.sliderItems).filter(
      element => element.clientHeight > 0
    );
    this.sliderLastItem = sliderItemsToShow[sliderItemsToShow.length - 1];
    if (sliderItemsToShow.length === 0) return;
    this.slidesPerPage = Math.floor(
      this.slider.clientHeight / sliderItemsToShow[0].clientHeight
    );
    this.totalPages = sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  update() {
    if (!this.pageCount || !this.pageTotal) return;
    this.currentPage =
      Math.round(this.slider.scrollTop / this.sliderLastItem.clientHeight) + 1;

    if (this.currentPage === 1) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.currentPage === this.totalPages) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }

    this.pageCount.textContent = this.currentPage;
    this.pageTotal.textContent = this.totalPages;
  }

  onButtonClick(event) {
    event.preventDefault();
    const slideScrollPosition =
      event.currentTarget.name === 'next'
        ? this.slider.scrollTop + this.sliderLastItem.clientHeight
        : this.slider.scrollTop - this.sliderLastItem.clientHeight;
    this.slider.scrollTo({
      top: slideScrollPosition
    });
  }
}

customElements.define('slider-thumbnails', SliderThumbnails);
class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
    window.addEventListener('load', event => {
      this.onLoadTranslation();
    });
  }

  onVariantChange() {
    document.querySelector('button.fostr-bis-register').classList.add('hidden');
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.updateSku();
    this.updateLabels();
    this.updateURL();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateColourLabel();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
      this.updatePreorderMessaging();
    }
  }

  onLoadTranslation() {
    this.updateOptions();
    this.updateMasterId();
    this.updateColourLabel();
  }

  updateOptions() {
    this.options = Array.from(
      this.querySelectorAll('select'),
      select => select.value
    );
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find(variant => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateColourLabel() {
    const variantTitle = this.currentVariant.title;
    const variantLabel = document.getElementById('colorLabel');
    variantLabel.innerHTML = ' - ' + variantTitle;
  }

  updateSku() {
    document.getElementsByClassName('product__sku')[0].innerHTML =
      this.currentVariant.sku;
    document
      .querySelector('#configure-moynat')
      ?.setAttribute('data-sku', this.currentVariant.sku);
    document.querySelector('personalisation-modal')?.variantChange();
  }

  updateLabels() {
    const variantId = this.currentVariant.id;
    const selectedVariant = document.getElementById(
      `label-product-${variantId}`
    );
    const labels = document.getElementsByClassName('pdp-variant-labels');

    if (!selectedVariant) return;

    for (let i = 0; i < labels.length; i++) {
      labels[i].classList.add('hidden');
    }

    selectedVariant.classList.remove('hidden');
  }

  updateMedia() {
    const variantId = this.currentVariant.id;
    const allVariantThumbnails = document.getElementsByClassName(
      'variant-thumb-list-item'
    );
    const allVariantImages = document.getElementsByClassName(
      'variant-images-list-item'
    );
    const variantThumbnails = document.getElementById(
      `variant-thumbnails-${variantId}`
    );
    const allSliders = document.getElementsByClassName(
      `moynat-product-gallery`
    );
    const variantImages = document.getElementById(
      `variant-images-${variantId}`
    );
    const variantSlider = document.getElementById(
      `moynat-product-gallery--${variantId}`
    );
    const allVariantDots =
      document.getElementsByClassName(`navigation-wrapper`);
    const variantDots = document.getElementById(
      `navigation-wrapper-${variantId}`
    );

    window.scroll({ top: 0, left: 0, behavior: 'smooth' });

    for (let i = 0; i < allVariantDots.length; i++) {
      allVariantDots[i].classList.add('hidden');
    }
    for (let i = 0; i < allSliders.length; i++) {
      allSliders[i].classList.add('hidden');
    }

    for (let i = 0; i < allVariantThumbnails.length; i++) {
      allVariantThumbnails[i].classList.add('hidden');
    }

    for (let i = 0; i < allVariantImages.length; i++) {
      allVariantImages[i].classList.add('hidden');
    }

    if (variantDots != null) {
      variantDots.classList.remove('hidden');
    }
    variantImages.classList.remove('hidden');
    variantSlider.classList.remove('hidden');
    variantThumbnails.classList.remove('hidden');

    setTimeout(() => {
      window.dispatchEvent(new Event('resize'));
    }, 500);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState(
      {},
      '',
      `${this.dataset.url}?variant=${this.currentVariant.id}`
    );
  }

  updateShareUrl() {
    const shareButton = document.getElementById(
      `Share-${this.dataset.section}`
    );
    if (!shareButton) return;
    shareButton.updateUrl(
      `${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`
    );
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment`
    );
    productForms.forEach(productForm => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
    const productFormButtons = document.querySelector(
      `#product-form-${this.dataset.section} .product-form__buttons`
    );
    productFormButtons.setAttribute('data-varid', this.currentVariant.id);
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  updatePreorderMessaging() {
    const preOrderMessage = document.getElementsByClassName(`preorder-message`);
    const currentVariantMessage = document.querySelector(
      `[data-preorder-variant="${this.currentVariant.id}"]`
    );
    const productForm = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    const addButtonText = productForm.querySelector('[name="add"] > span');

    for (let i = 0; i < preOrderMessage.length; i++) {
      preOrderMessage[i].classList.remove('active');
    }

    if (!currentVariantMessage) return;
    currentVariantMessage.classList.add('active');
    addButtonText.textContent = window.variantStrings.preorder;
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    // if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    fetch(
      `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`
    )
      .then(response => response.text())
      .then(responseText => {
        const id = `price-${this.dataset.section}`;
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const destination = document.getElementById(id);
        const source = html.getElementById(id);

        if (source && destination) destination.innerHTML = source.innerHTML;

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('visibility-hidden');
        this.toggleAddButton(
          !this.currentVariant.available,
          window.variantStrings.soldOut
        );
        this.updatePreorderMessaging();
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    const addButtonAnimate = productForm.querySelector(
      '[name="add"] > .loading-overlay__spinner'
    );
    const notifyButton = productForm.querySelector('button.fostr-bis-register');
    const customAddButton = document.querySelector(
      'personalisation-modal .personalisation__cart-cta'
    );
    const activeRecipeCntr = document.querySelector(
      '.personalisation__active-recipe'
    );
    let activeRecipe = false;

    if (activeRecipeCntr) {
      if (activeRecipeCntr.classList.contains('visible')) {
        activeRecipe = true;
      }
    }

    if (!addButton) return;

    addButton.classList.remove('hidden');
    addButton.setAttribute('disabled', 'disabled');
    addButtonText.textContent = '';
    addButtonAnimate.classList.remove('hidden');
    notifyButton.classList.add('hidden');
    if (customAddButton) {
      customAddButton.classList.add('hidden');
    }

    if (disable) {
      if (text != '') {
        // Confirmed out of stock
        addButtonAnimate.classList.add('hidden');
        addButtonText.textContent = text;
        addButton.classList.add('hidden');
        notifyButton.classList.remove('hidden');
        if (customAddButton) {
          customAddButton.setAttribute('disabled', 'disabled');
          customAddButton.classList.add('hidden');
        }
      }
    } else {
      if (activeRecipe) {
        document.querySelector('.product-form-buy-buttons').style.display =
          'none';
      }
      if (customAddButton) {
        customAddButton.removeAttribute('disabled');
        customAddButton.classList.remove('hidden');
      }
      addButtonAnimate.classList.add('hidden');
      addButtonText.textContent = window.variantStrings.addToCart;
      addButton.removeAttribute('disabled');
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map(fieldset => {
      return Array.from(fieldset.querySelectorAll('input')).find(
        radio => radio.checked
      ).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);

class Accordion {
  constructor(el) {
    this.el = el;
    this.summary = el.querySelector('summary');
    this.content = el.querySelector('.accordion__content');
    this.insetclose = el.querySelector('inset-close');
    this.animation = null;
    this.isClosing = false;
    this.isExpanding = false;
    this.summary.addEventListener('click', e => this.onClick(e));

    if (this.insetclose) {
      this.insetclose.addEventListener('click', e => this.onClick(e));
    }
  }

  onClick(e) {
    e.preventDefault();
    if (this.isClosing || !this.el.open) {
      if (this.el.classList.contains('nested-accordion')) {
        this.closeAll(true);
      } else {
        this.closeAll(false);
      }
      this.open();
    } else if (this.isExpanding || this.el.open) {
      this.shrink();
    }
  }

  shrink() {
    this.isClosing = true;
    const startHeight = `${this.el.offsetHeight}px`;
    const endHeight = `${this.summary.offsetHeight}px`;
    if (this.animation) {
      this.animation.cancel();
    }
    this.animation = this.el.animate(
      {
        height: [startHeight, endHeight]
      },
      {
        duration: 200,
        easing: 'ease-in-out'
      }
    );
    this.animation.onfinish = () => this.onAnimationFinish(false);
    this.animation.oncancel = () => (this.isClosing = false);
  }

  open() {
    this.el.style.height = `${this.el.offsetHeight}px`;
    this.el.open = true;
    window.requestAnimationFrame(() => this.expand());
  }

  expand() {
    this.isExpanding = true;
    const startHeight = `${this.el.offsetHeight}px`;
    const endHeight = `${this.summary.offsetHeight + this.content.offsetHeight}px`;
    if (this.animation) {
      this.animation.cancel();
    }
    this.animation = this.el.animate(
      {
        height: [startHeight, endHeight]
      },
      {
        duration: 200,
        easing: 'ease-in-out'
      }
    );
    this.animation.onfinish = () => this.onAnimationFinish(true);
    this.animation.oncancel = () => (this.isExpanding = false);
  }

  onAnimationFinish(open) {
    this.el.open = open;
    this.animation = null;
    this.isClosing = false;
    this.isExpanding = false;
    this.el.style.height = this.el.style.overflow = '';
  }

  closeAll(subAccordions) {
    let allAccordions;
    if (subAccordions) {
      allAccordions = document.querySelectorAll('details.nested-accordion');
    } else {
      allAccordions = document.querySelectorAll('details');
    }
    allAccordions.forEach(accordionEl => {
      accordionEl.removeAttribute('open');
    });
  }
}

document.querySelectorAll('details.with-sliding').forEach(el => {
  new Accordion(el);
});

class fostrGridToggle extends HTMLElement {
  constructor() {
    super();
    this.expandedViewButton = this.querySelector('#expandedViewButton');
    this.standardViewButton = this.querySelector('#standardViewButton');

    this.expandedViewButton.addEventListener(
      'click',
      this.onButtonClick.bind(this)
    );
    this.standardViewButton.addEventListener(
      'click',
      this.onButtonClick.bind(this)
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const colID = event.currentTarget.id;
    if (colID == 'expandedViewButton') {
      document
        .getElementById('ProductGridContainer')
        .classList.remove('grid-enhanced-view');
      this.expandedViewButton.classList.add('active');
      this.standardViewButton.classList.remove('active');
    } else {
      document
        .getElementById('ProductGridContainer')
        .classList.add('grid-enhanced-view');
      this.standardViewButton.classList.add('active');
      this.expandedViewButton.classList.remove('active');
    }
  }
}
customElements.define('fostr-layout-toggle', fostrGridToggle);

class secondaryHoverImage extends HTMLElement {
  constructor() {
    super();
    this.images = this.querySelectorAll('img');
    this.addEventListener('mouseenter', e => this.onEnter(e));
    this.addEventListener('mouseleave', e => this.onLeave(e));
  }

  onEnter(e) {
    if (this.images.length !== 2) return;
    this.images[0].classList.remove('show');
    this.images[1].classList.add('show');
  }

  onLeave(e) {
    if (this.images.length !== 2) return;
    this.images[0].classList.add('show');
    this.images[1].classList.remove('show');
  }
}
customElements.define('hover-image-block', secondaryHoverImage);

class variantSwitchControl extends HTMLElement {
  constructor() {
    super();
    const toggles = this.querySelectorAll('[data-variant-switch-toggle]');

    toggles.forEach(button => {
      button.addEventListener('click', this.toggleVariant.bind(this));
      if (button.classList.contains('selected')) {
        this.switchVariant(button.getAttribute('data-product-option-id'));
      }
    });
  }

  toggleVariant(event) {
    event.preventDefault();
    let eventNode;
    if (event.target.getAttribute('data-product-option-id') == null) {
      eventNode = event.target.parentNode;
    } else {
      eventNode = event.target;
    }

    if (eventNode.classList.contains('selected')) return;
    const toggles = this.querySelectorAll('[data-variant-switch-toggle]');
    const variantID = eventNode.getAttribute('data-product-option-id');

    toggles.forEach(option => option.classList.remove('selected'));
    eventNode.classList.add('selected');
    this.switchVariant(variantID);
  }

  switchVariant(variantID) {
    const blocks = this.querySelectorAll('[data-variant-switch-block]');
    const items = this.querySelectorAll('[data-variant-switch-item]');

    items.forEach(option => {
      if (option.getAttribute('data-variant-switch-ids').length == 0) return;
      if (option.getAttribute('data-variant-switch-ids').includes(variantID)) {
        option.classList.add('show');
      } else {
        option.classList.remove('show');
      }
    });
  }
}
customElements.define('variant-switch-container', variantSwitchControl);

class atcTrigger extends HTMLElement {
  constructor() {
    super();

    this.button = this.querySelector('[data-quick-buy-btn]');
    this.cartItems = document.querySelector('cart-items');
    this.miniCart = document.getElementById('mini-cart');

    if (!this.button) {
      return;
    }

    this.button.addEventListener('click', this.onClickHandler.bind(this));
  }

  onClickHandler(event) {
    event.preventDefault();

    this.variantIds = this.getAttribute('variant-ids');
    this.properties = this.getAttribute('line-item-props');
    this.fade = !!this.getAttribute('fade');

    if (!this.variantIds) {
      return;
    }

    this.button.setAttribute('disabled', true);
    this.button.classList.add('loading');

    if (this.fade) {
      this.classList.add(
        'animate__animated',
        'animate__fadeOut',
        'animate__faster'
      );
    }

    const quantityEl = this.querySelector('input[name="quantity"]');
    const quantity = quantityEl ? parseInt(quantityEl.value) : 1;

    let properties;
    if (this.properties) {
      try {
        properties = JSON.parse(this.properties);
      } catch (err) {
        console.error(err);
      }
    }

    let itemsArr = [];
    const varIdsArr = this.variantIds.split(',');
    varIdsArr.forEach(varId => {
      itemsArr.push({
        id: varId,
        quantity: quantity,
        properties: properties
      });
    });

    let body = {
      items: itemsArr
    };

    if (this.cartItems) {
      body.sections = this.cartItems
        .getSectionsToRender()
        .map(section => section.id);
      body.sections_url = window.location.pathname;
    }

    body = JSON.stringify(body);

    fetch(`${routes.cart_add_url}`, { ...fetchConfig('javascript'), body })
      .then(response => response.json())
      .then(parsedState => {
        if (!parsedState.items && parsedState.message) {
          if (parsedState.status == 422) {
            document
              .querySelector('.mini-cart-add-error')
              .classList.remove('hidden');
            this.miniCart?.open();
          }
          return this.dispatchEvent(
            new CustomEvent('fostr-quick-buy-done', {
              bubbles: true,
              detail: { status: 'error', info: parsedState }
            })
          );
        }

        this.dispatchEvent(
          new CustomEvent('fostr-quick-buy-done', {
            bubbles: true,
            detail: { status: 'success' }
          })
        );

        let fadeClass = '';
        if (this.fade) {
          varIdsArr.forEach((id, index) => {
            if (fadeClass === '') {
              fadeClass += `.variant-id-${id}`;
            } else {
              fadeClass += `, .variant-id-${id}`;
            }
          });
        }
        this.cartItems?.renderContents(parsedState, fadeClass);
        return this.cartItems?.checkGifts();
      })
      .catch(error => {
        this.dispatchEvent(
          new CustomEvent('fostr-quick-buy-done', {
            bubbles: true,
            detail: { status: 'error', error: error }
          })
        );
        console.error(error);
      })
      .finally(() => {
        this.button.classList.remove('loading');
        this.button.removeAttribute('disabled');
        document.querySelector('body').classList.remove('quick-buy-open');
        let cardWrapper = document.getElementsByClassName('card-wrapper');
        for (let i = 0; i < cardWrapper.length; i++) {
          cardWrapper[i].classList.remove('active');
        }
      });
  }
}

customElements.define('add-to-cart-button', atcTrigger);

class CartUpsells extends HTMLElement {
  constructor() {
    super();

    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);
      this.update();
    };

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: '0px 0px 200px 0px'
    }).observe(this);
  }

  update() {
    return fetch(this.dataset.url)
      .then(response => response.text())
      .then(text => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('cart-upsells');
        if (recommendations && recommendations.innerHTML.trim().length) {
          this.innerHTML = recommendations.innerHTML;
        }
        function simulateClick(elem) {
          // Create our event (with options)
          var evt = new MouseEvent('click', {
            bubbles: true,
            cancelable: true,
            view: window
          });
          // If cancelled, don't dispatch our event
          var canceled = !elem.dispatchEvent(evt);
        }
        const button = document.getElementById('countryWatchReload');
        simulateClick(button);
      })
      .catch(e => {
        console.error(e);
      });
  }
}

customElements.define('cart-upsells', CartUpsells);

class formValidator extends HTMLElement {
  constructor() {
    super();
    const inputs = this.querySelectorAll('input, select');
    const textareas = this.querySelectorAll('textarea');

    inputs.forEach(input => {
      if (input.getAttribute('data-preset') !== null) {
        this.presetRequest(input, input.getAttribute('data-preset'));
      }
      if (input.type !== 'hidden' && input.value.length > 0) {
        input.nextElementSibling.classList.add('input-filled');
      }
    });

    textareas.forEach(textarea => {
      if (textarea.type !== 'hidden' && textarea.value.length > 0) {
        textarea.nextElementSibling.classList.add('input-filled');
      }
    });

    this.addEventListener('input', this.onChange.bind(this));
  }

  onChange(event) {
    event.preventDefault();
    if (event.target.value.length > 0) {
      event.target.nextElementSibling.classList.add('input-filled');
      event.target.parentElement.classList.remove('invalid');
    } else {
      event.target.nextElementSibling.classList.remove('input-filled');
      if (
        event.target.parentElement.classList.contains('form-control--required')
      ) {
        event.target.parentElement.classList.add('invalid');
      }
    }
  }

  presetRequest(presetInput, presetReq) {
    switch (presetReq) {
      case 'last-product':
        const urlParts = document.referrer.split('/');
        const lastPage = urlParts[urlParts.length - 1].split('?');
        if (urlParts[urlParts.length - 2] == 'products') {
          const lastProduct = lastPage[0];
          const lastVariant = lastPage[1];
          fetch(`/products/${lastProduct}.json`)
            .then(response => response.json())
            .then(responseText => {
              if (lastVariant) {
                const variantData = lastVariant.split('=');
                const variantID = variantData[variantData.length - 1];
                let currentVariant;
                for (
                  currentVariant = 0;
                  currentVariant < responseText.product.variants.length;
                  currentVariant++
                ) {
                  if (
                    variantID ==
                    responseText.product.variants[currentVariant].id
                  ) {
                    presetInput.value =
                      responseText.product.variants[currentVariant].sku;
                    presetInput.nextElementSibling.classList.add(
                      'input-filled'
                    );
                  }
                }
              } else {
                presetInput.value = responseText.product.variants[0].sku;
                presetInput.nextElementSibling.classList.add('input-filled');
              }
            });
        }
        break;

      case 'user-country':
        this.fetchUserJSON().then(userData => {
          if (userData) {
            let userCountry = userData.country_name;
            userCountry = userCountry.toLowerCase().replace(/\W+/g, '-');
            presetInput.value = userCountry;
          }
        });
        break;

      case 'user-dialling':
        this.fetchUserJSON().then(userData => {
          if (userData) {
            const userDialling = this.querySelector(
              'option[data-countrycode="' + userData.country.handle + '"]'
            ).value;
            presetInput.value = userDialling;
          }
        });
        break;

      case 'user-lang':
        const browserLang = navigator.language.substring(0, 2);
        if (browserLang == 'en') {
          presetInput.value = 'english';
        } else if (browserLang == 'fr') {
          presetInput.value = 'francais';
        } else if (browserLang == 'zh') {
          presetInput.value = '中国人';
        }
        break;
    }
  }

  async fetchUserJSON() {
    let response = await fetch(`/browsing_context_suggestions.json`);
    let data = await response.json();
    return data.detected_values;
  }
}
customElements.define('form-container', formValidator);

class searchToggle extends HTMLElement {
  constructor() {
    super();
    this.querySelector('.search-close')?.addEventListener(
      'click',
      this.toggleSearch.bind(this)
    );
    document
      .getElementById('SearchToggleDesktop')
      .addEventListener('click', this.toggleSearch.bind(this));
    document
      .getElementById('SearchOverlay')
      .addEventListener('click', this.toggleSearch.bind(this));
  }

  toggleSearch(event) {
    event.preventDefault();
    const headerEl = document.getElementById('shopify-section-moynat-header');
    const searchOverlay = document.getElementById('SearchOverlay');
    const announcmentBarEl = document.getElementById(
      'shopify-section-moynat-announcement-bar'
    );

    if (this.classList.contains('height-zero')) {
      this.classList.remove('height-zero');
      headerEl.classList.add('search-open');
      searchOverlay.classList.add('search-open');
      announcmentBarEl.classList.add('search-open');
      setTimeout(function () {
        document.getElementById('Search-In-Modal').focus();
      }, 1000);
    } else {
      this.classList.add('height-zero');
      headerEl.classList.remove('search-open');
      searchOverlay.classList.remove('search-open');
      announcmentBarEl.classList.remove('search-open');
    }
  }
}
customElements.define('search-menu', searchToggle);

class contentDataFilter extends HTMLElement {
  constructor() {
    super();

    const filterItems = document.querySelectorAll('[data-filter-nav]');
    const filterBlocks = document.querySelectorAll('[data-filter-block]');

    filterItems.forEach(item => {
      this.querySelector('content-filter-nav ul').appendChild(item);
      item
        .querySelector('button')
        .addEventListener('click', this.toggleFilter.bind(this));
    });

    filterBlocks.forEach(item => {
      this.querySelector('content-filter-blocks').appendChild(item);
    });
  }

  toggleFilter(filterData) {
    let filterHandle = filterData.target.getAttribute('data-filter-control');
    const controls = this.querySelectorAll('[data-filter-control]');
    const contentBlocks = document.querySelectorAll('[data-filter-block]');
    const filterCntr = document.querySelector('.filter-container');

    if (filterData.target.classList.contains('active-url')) {
      filterCntr.classList.remove('stores-filtered');
      filterHandle = 'all';
    } else {
      filterCntr.classList.add('stores-filtered');
    }

    controls.forEach(control => {
      if (control.getAttribute('data-filter-control') == filterHandle) {
        control.classList.add('active-url');
      } else {
        control.classList.remove('active-url');
      }
    });

    contentBlocks.forEach(block => {
      if (
        filterHandle == 'all' ||
        block.getAttribute('data-filter-value') == filterHandle
      ) {
        block.classList.remove('hide');
      } else {
        block.classList.add('hide');
      }
    });
  }
}
customElements.define('content-filter', contentDataFilter);

class faqFunctions extends HTMLElement {
  constructor() {
    super();
    const buttons = this.querySelectorAll('button');
    const backButtons = this.querySelectorAll('.back-button button');

    buttons.forEach(button => {
      button.addEventListener('click', e => this.faqClicked(e));
    });
    backButtons.forEach(bbutton => {
      bbutton.addEventListener('click', this.backClicked.bind(this));
    });
  }

  faqClicked(e) {
    const topic = e.target.getAttribute('data-topic-handle');
    const question = e.target.getAttribute('data-question-id');
    const topicBlks = document.querySelectorAll(
      '.faq-page-wrapper .shopify-section'
    );

    this.fadeOut();
    setTimeout(() => {
      this.refineTopics(topic, question, topicBlks);
    }, 300);

    setTimeout(() => {
      this.fadeIn();
    }, 300);
  }

  fadeOut() {
    document.querySelector('body').classList.add('fadeout');
  }

  refineTopics(topic, question, topicBlks) {
    topicBlks.forEach(blk => {
      if (blk.children[0].getAttribute('data-topic-handle') == topic) {
        blk.classList.remove('hide');
        const questions = blk.querySelectorAll('details');
        if (question == 'all') {
          questions.forEach(q => {
            q.removeAttribute('open');
          });
        } else {
          questions.forEach(q => {
            if (q.getAttribute('data-question-id') == question) {
              q.setAttribute('open', true);
            } else {
              q.removeAttribute('open');
            }
          });
        }
      } else {
        blk.classList.add('hide');
      }
    });

    window.scrollTo(0, 0);
    document
      .querySelector('.faq-page-wrapper')
      .classList.remove('landing-view');
    document.querySelector('.faq-page-wrapper').classList.add('topic-view');
  }

  returnTopics(topicBlks) {
    topicBlks.forEach(blk => {
      blk.classList.remove('hide');
    });

    document.querySelector('.faq-page-wrapper').classList.remove('topic-view');
    document.querySelector('.faq-page-wrapper').classList.add('landing-view');
  }

  fadeIn() {
    document.querySelector('body').classList.remove('fadeout');
  }

  backClicked() {
    const topicBlks = document.querySelectorAll(
      '.faq-page-wrapper .shopify-section'
    );

    this.fadeOut();
    setTimeout(() => {
      this.returnTopics(topicBlks);
    }, 300);

    setTimeout(() => {
      this.fadeIn();
    }, 300);
  }
}
customElements.define('faq-topic-block', faqFunctions);

let announcementBar = document.getElementById('announcement-bar');

document.addEventListener('DOMContentLoaded', function () {
  // setTimeout(function(){
  //   document.body.classList.add('fade-in');
  // }, 500);

  let announcementClose = document.getElementById('announcement__close');

  if (announcementClose !== null) {
    announcementClose.addEventListener('click', function () {
      document.getElementById('announcement-bar').classList.add('hidden');
      announcementClose.classList.add('hidden');
    });
  }

  // PDP Zoom In Functionality
  const lightboxButtons = document.querySelectorAll('[data-lightbox]');
  const mobileLightboxButtons = document.querySelectorAll(
    '.product-gallery__slide'
  );
  const lightboxImage = document.getElementById('moynat-lightbox__image');
  const lightbox = document.getElementById('moynat-lightbox');
  const lightboxClose = document.getElementById('moynat-lightbox__cross');

  // Desktop Lightbox
  lightboxButtons.forEach(function (lightboxButton) {
    lightboxButton.addEventListener('click', function () {
      let src = lightboxButton.getAttribute('data-lightbox');
      lightbox.classList.add('visible');
      lightbox.querySelector('img').setAttribute('src', src);
    });
  });

  // Mobile Lightbox
  mobileLightboxButtons.forEach(function (mobileLightboxButton) {
    mobileLightboxButton.addEventListener('click', function () {
      let src = mobileLightboxButton.getAttribute('data-lightbox');
      lightbox.classList.add('visible');
      lightbox.querySelector('img').setAttribute('src', src);
    });
  });

  function zoomOutMobile() {
    var viewport = document.querySelector('meta[name="viewport"]');

    if (viewport) {
      viewport.content = 'initial-scale=1';
      viewport.content = 'width=device-width';
    }
  }

  // Close Lightbox Function
  if (lightboxClose !== null) {
    lightboxClose.addEventListener('click', function () {
      lightbox.classList.remove('visible');
      lightbox.querySelector('img').setAttribute('src', '');
      zoomOutMobile();
    });
  }

  // Close Lightbox Function
  if (lightboxImage !== null) {
    lightboxImage.addEventListener('click', function () {
      lightbox.classList.toggle('zoomed');
    });
  }
});

function navigation(slider) {
  let wrapper, dots, arrowLeft, arrowRight;

  function markup(remove) {
    wrapperMarkup(remove);
    dotMarkup(remove);
    arrowMarkup(remove);
  }

  function removeElement(elment) {
    elment.parentNode.removeChild(elment);
  }
  function createDiv(className) {
    var div = document.createElement('div');
    var classNames = className.split(' ');
    classNames.forEach(name => div.classList.add(name));
    return div;
  }

  function arrowMarkup(remove) {
    if (remove) {
      removeElement(arrowLeft);
      removeElement(arrowRight);
      return;
    }
    arrowLeft = createDiv('arrow arrow--left');
    arrowLeft.innerHTML =
      '<?xml version="1.0" encoding="UTF-8" standalone="no"?><!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd"><svg width="100%" height="100%" viewBox="0 0 259 417" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xml:space="preserve" xmlns:serif="http://www.serif.com/" style="fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2;"><g><path d="M208.498,206.824c-0.417,-3.75 -1.667,-7.083 -4.167,-10l-150,-166.666c-6.25,-7.084 -16.666,-7.5 -23.75,-1.25c-7.083,6.25 -7.5,16.666 -1.25,23.75l140,155.416l-140,155.417c-6.25,6.667 -5.833,17.5 1.25,23.75c6.667,6.25 17.5,5.833 23.75,-1.25l150,-166.667c2.917,-3.75 4.584,-8.333 4.167,-12.5Z" style="fill-rule:nonzero;"/></g></svg>';
    arrowLeft.addEventListener('click', () => slider.prev());
    arrowRight = createDiv('arrow arrow--right');
    arrowRight.innerHTML =
      '<?xml version="1.0" encoding="UTF-8" standalone="no"?><!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd"><svg width="100%" height="100%" viewBox="0 0 259 417" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xml:space="preserve" xmlns:serif="http://www.serif.com/" style="fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2;"><g><path d="M208.498,206.824c-0.417,-3.75 -1.667,-7.083 -4.167,-10l-150,-166.666c-6.25,-7.084 -16.666,-7.5 -23.75,-1.25c-7.083,6.25 -7.5,16.666 -1.25,23.75l140,155.416l-140,155.417c-6.25,6.667 -5.833,17.5 1.25,23.75c6.667,6.25 17.5,5.833 23.75,-1.25l150,-166.667c2.917,-3.75 4.584,-8.333 4.167,-12.5Z" style="fill-rule:nonzero;"/></g></svg>';
    arrowRight.addEventListener('click', () => slider.next());

    wrapper.appendChild(arrowLeft);
    wrapper.appendChild(arrowRight);
  }

  function wrapperMarkup(remove) {
    if (remove) {
      var parent = wrapper.parentNode;
      while (wrapper.firstChild)
        parent.insertBefore(wrapper.firstChild, wrapper);
      removeElement(wrapper);
      return;
    }
    wrapper = createDiv('navigation-wrapper');
    wrapper.setAttribute('id', 'navigation-wrapper');
    slider.container.parentNode.appendChild(wrapper);
    wrapper.appendChild(slider.container);
  }

  function dotMarkup(remove) {
    if (remove) {
      removeElement(dots);
      return;
    }
    dots = createDiv('dots');
    slider.track.details.slides.forEach((_e, idx) => {
      var dot = createDiv('dot');
      dot.addEventListener('click', () => slider.moveToIdx(idx));
      dots.appendChild(dot);
    });
    wrapper.appendChild(dots);
  }

  function updateClasses() {
    var slide = slider.track.details.rel;
    slide === 0
      ? arrowLeft.classList.add('arrow--disabled')
      : arrowLeft.classList.remove('arrow--disabled');
    slide === slider.track.details.slides.length - 1
      ? arrowRight.classList.add('arrow--disabled')
      : arrowRight.classList.remove('arrow--disabled');
    Array.from(dots.children).forEach(function (dot, idx) {
      idx === slide
        ? dot.classList.add('dot--active')
        : dot.classList.remove('dot--active');
    });
  }

  slider.on('created', () => {
    markup();
    updateClasses();
  });
  slider.on('optionsChanged', () => {
    markup(true);
    markup();
    updateClasses();
  });
  slider.on('slideChanged', () => {
    updateClasses();
  });
  slider.on('destroyed', () => {
    markup(true);
  });
}

if (announcementBar !== null) {
  var slider = new KeenSlider(
    '#announcement-bar',
    {
      loop: true,
      defaultAnimation: {
        duration: 250
      },
      detailsChanged: s => {
        // Set the height of the announcement banner to be height of the tallest div
        var greatestHeight = 0;
        var elements = document.querySelectorAll('.announcement-bar__message');
        elements.forEach(function (element, index) {
          greatestHeight =
            element.offsetHeight > greatestHeight
              ? element.offsetHeight
              : greatestHeight;
        });

        announcementBar.style.minHeight = `${greatestHeight}px`;

        s.slides.forEach((element, idx) => {
          element.style.minHeight = `${greatestHeight}px`;
          element.style.opacity = s.track.details.slides[idx].portion;
          element.style.zIndex = s.track.details.slides[idx].portion;
          element.style.display = 'flex';
        });
      },
      updated: s => {
        // Set the height of the announcement banner to be height of the tallest div
        var greatestHeight = 0;
        var elements = document.querySelectorAll('.announcement-bar__message');
        elements.forEach(function (element, index) {
          greatestHeight =
            element.offsetHeight > greatestHeight
              ? element.offsetHeight
              : greatestHeight;
        });

        announcementBar.style.minHeight = `${greatestHeight}px`;

        s.slides.forEach((element, idx) => {
          element.style.minHeight = `${greatestHeight}px`;
          element.style.zIndex = s.track.details.slides[idx].portion;
          element.style.opacity = s.track.details.slides[idx].portion;
          element.style.display = 'flex';
        });
      },
      created: s => {
        let tallestSlide = 0;
        let navWrapper = document.getElementById('navigation-wrapper');
        s.slides.forEach((element, idx) => {
          let contentWidth = element.querySelector(
            '.announcement-bar__message'
          ).clientWidth;
          element.style.zIndex = s.track.details.slides[idx].portion;
          if (s.track.details.rel === idx) {
            contentWidth = contentWidth + 40;
            navWrapper.style.maxWidth = '100%';
          }
        });

        // Set the height of the announcement banner to be height of the tallest div
        var greatestHeight = 0;
        var elements = document.querySelectorAll('.announcement-bar__message');
        elements.forEach(function (element, index) {
          greatestHeight =
            element.offsetHeight > greatestHeight
              ? element.offsetHeight
              : greatestHeight;
        });

        announcementBar.style.minHeight = `${greatestHeight}px`;

        s.slides.forEach((element, idx) => {
          element.style.minHeight = `${greatestHeight}px`;
          element.style.opacity = s.track.details.slides[idx].portion;
          element.style.zIndex = s.track.details.slides[idx].portion;
          element.style.display = 'flex';
        });
      },
      slideChanged: s => {
        document.getElementById('navigation-wrapper').style.maxWidth = '100%';
        s.slides.forEach((element, idx) => {
          if (s.track.details.rel === idx) {
            let contentWidth = element.querySelector(
              '.announcement-bar__message'
            ).clientWidth;
            contentWidth = contentWidth + 25;
            let navWrapper = document.getElementById('navigation-wrapper');
            navWrapper.style.maxWidth = '100%';
            element.style.zIndex = '0';
          }
        });
      },
      renderMode: 'custom'
    },
    [navigation]
  );

  // Auto rotate announcement bar
  const announcementBarWrapper = document.getElementById('navigation-wrapper');
  const autoRotateDelay = parseInt(announcementBar.dataset.delay) * 1000;
  let autoRotationStopped = autoRotateDelay === 0;
  let rotationInterval = null;

  const startAutoRotation = () => {
    if (autoRotationStopped) return;
    rotationInterval = setInterval(() => {
      slider.next();
    }, autoRotateDelay);
  };
  startAutoRotation();
  const stopAutoRotation = () => clearInterval(rotationInterval);

  announcementBarWrapper.addEventListener('mouseenter', () =>
    stopAutoRotation()
  );
  announcementBarWrapper.addEventListener('mouseleave', () =>
    startAutoRotation()
  );
  announcementBarWrapper.addEventListener('click', () => {
    stopAutoRotation();
    autoRotationStopped = true;
  });
}

// data-country-specific data-country-replace-cta-button data-country-replace-cta-textlink
class countrySpecificManager extends HTMLElement {
  constructor() {
    super();
    const elements = this.querySelectorAll('[data-country-specific]');
    const paginateRefresh = this.querySelector('#countryWatchReload');
    // const viewRestrictedToggle = this.querySelector('#country__restricted');
    // const viewUnrestrictedToggle = this.querySelector('#country__unrestricted');
    // const showUnrestricted = sessionStorage.getItem('unrestricted_view');

    // this.checkPreviewTheme();

    // viewRestrictedToggle.addEventListener('click', function(){
    //   console.log(1);
    //   sessionStorage.setItem('unrestricted_view', false);
    //   location.reload();
    // });

    // viewUnrestrictedToggle.addEventListener('click', function(){
    //   console.log(2);
    //   sessionStorage.setItem('unrestricted_view', true);
    //   location.reload();
    // });

    if (elements.length > 0) {
      // Check if local storage country exists
      const localStored = this.getWithExpiry();
      if (!localStored) {
        // No local storage country already exists so fetch data
        this.fetchUserJSON().then(userData => {
          if (userData) {
            // Set local storage for next time (with 24h expiry)
            this.setWithExpiry(userData.country.handle);
            // See if country is approved
            // const withinCountries = this.checkWithinCountries(userData.country.handle);
            // if (!withinCountries && showUnrestricted == 'false' || !withinCountries && showUnrestricted == null) {
            //   this.hideRelevantContent(elements);
            //   paginateRefresh.addEventListener('click', this.restartCheck.bind(this));
            // }
          }
        });
      } else {
        // Check if existing local storage country is approved
        // const withinCountries = this.checkWithinCountries(localStored);
        // if (!withinCountries && showUnrestricted == 'false' || !withinCountries && showUnrestricted == null) {
        //   this.hideRelevantContent(elements);
        //   paginateRefresh.addEventListener('click', this.restartCheck.bind(this));
        // }
      }
    }
  }

  // Onload Check
  // checkPreviewTheme() {
  //   const previewSwitcher = this.querySelector('#country__switch');
  //   let isPreviewTheme = this.getCookie("preview_theme") == 1 ? true : false;
  //   const sessionStorageView = sessionStorage.getItem('unrestricted_view');
  //   const currentURL = window.location.href;

  //   if(currentURL.includes("shopifypreview")) {
  //     isPreviewTheme = true;
  //   }

  //   if(isPreviewTheme == true) {
  //     console.log(isPreviewTheme,sessionStorageView);
  //     if(sessionStorageView === 'true') {
  //       this.querySelector('#country__unrestricted').classList.add('active');
  //     } else if(sessionStorageView === 'false') {
  //       this.querySelector('#country__restricted').classList.add('active');
  //     }
  //     previewSwitcher.classList.add('active');
  //   }
  // }

  // Toggle Button Click
  togglePreviewView(state) {
    const showUnrestricted = state;
    if (showUnrestricted == 'unrestricted') {
      sessionStorage.setItem('unrestricted_view', true);
      location.reload();
    } else {
      sessionStorage.setItem('unrestricted_view', false);
      location.reload();
    }
  }

  setWithExpiry(userValue) {
    let ttl = new Date();
    ttl.setHours(ttl.getHours() + 24);
    localStorage.setItem(
      'userCountry',
      JSON.stringify({ value: userValue, expiry: ttl })
    );
  }

  getCookie(name) {
    var cookieArr = document.cookie.split(';');
    for (var i = 0; i < cookieArr.length; i++) {
      var cookiePair = cookieArr[i].split('=');
      if (name == cookiePair[0].trim()) {
        return decodeURIComponent(cookiePair[1]);
      }
    }
    return null;
  }

  getWithExpiry() {
    const localObj = localStorage.getItem('userCountry');
    if (!localObj) {
      return null;
    }
    const item = JSON.parse(localObj);
    if (new Date() > new Date(item.expiry)) {
      localStorage.removeItem('userCountry');
      return null;
    }
    return item.value;
  }

  checkWithinCountries(currentLocation) {
    const availableCountries = window.shopShoppingZones.split(',');
    if (availableCountries.includes(currentLocation)) {
      return true;
    } else {
      return false;
    }
  }

  getCookie(cname) {
    let name = cname + '=';
    let ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return '';
  }

  hideRelevantContent(elements) {
    let currentLocale = this.getCookie('ly-lang-selected');
    if (currentLocale == 'fr') {
      currentLocale = 'fr/';
    } else if (currentLocale == 'zh-CN') {
      currentLocale = 'zh/';
    } else {
      currentLocale = '';
    }
    elements.forEach(element => {
      if (element.hasAttribute('data-country-replace-cta-button')) {
        element.innerHTML =
          `<div id="pdp__add-to-cart"><a href="/${currentLocale}pages/contact-us" class="button button--secondary country-contact-button">` +
          window.contactUsReplacement +
          '</a></div>';
      } else if (element.hasAttribute('data-country-replace-cta-textlink')) {
        element.innerHTML =
          `<div id="pdp__add-to-cart"><a href="/${currentLocale}pages/contact-us" class="button button--textlink country-contact-textlink">` +
          window.contactUsReplacement +
          '</a></div>';
      } else {
        element.classList.add('hidden');
      }
    });
  }

  restartCheck() {
    const elements = this.querySelectorAll('[data-country-specific]');
    this.hideRelevantContent(elements);
  }

  async fetchUserJSON() {
    let response = await fetch(`/browsing_context_suggestions.json`);
    let data = await response.json();
    return data.detected_values;
  }
}
customElements.define('country-validate', countrySpecificManager);

// Scroll To Top Functionality
let globalTicking = false;
const scrollEl = document.getElementById('scroll-to-top');
const productTemplate =
  document.getElementsByClassName('template-product').length > 0 ? true : false;
const collectionTemplate =
  document.getElementsByClassName('template-collection').length > 0
    ? true
    : false;
const indexTemplate =
  document.getElementsByClassName('template-index').length > 0 ? true : false;
const viewportWidth = window.matchMedia('(max-width: 1090px)');
let scrollElTrigged = false;

if (productTemplate || collectionTemplate || indexTemplate) {
  document.addEventListener('scroll', function (e) {
    if (!globalTicking) {
      window.requestAnimationFrame(function () {
        toggleScrollToTop();
        if (productTemplate) {
          updateAtcPlacement();
        }
        globalTicking = false;
      });

      globalTicking = true;
    }
  });

  scrollEl.addEventListener('click', scrollUp);

  function scrollUp() {
    document.body.scrollTop = 0; // For Safari
    document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
    scrollEl.classList.remove('sticky');
    scrollElTrigged = false;
  }

  function updateAtcPlacement() {
    if (viewportWidth.matches) {
      let elContainer = document.getElementById('pdp__add-to-cart-container');
      let el = document.getElementById('pdp__add-to-cart');
      let elDistanceToTop = elContainer.getBoundingClientRect().top;
      if (elDistanceToTop < 0) {
        el.classList.add('sticky-atc');
      } else {
        el.classList.remove('sticky-atc');
      }
    }
  }

  function toggleScrollToTop() {
    let footerEl = document.getElementById('shopify-section-moynat-footer');
    let distanceToFoooter = footerEl.getBoundingClientRect().top;

    if (collectionTemplate) {
      if (distanceToFoooter < 1250 && scrollElTrigged == false) {
        scrollElTrigged = true;
        scrollEl.classList.add('sticky');
      }
    } else {
      if (distanceToFoooter < 1250) {
        scrollEl.classList.add('sticky');
      } else {
        scrollEl.classList.remove('sticky');
      }
    }
  }
}
class servicesNav extends HTMLElement {
  constructor() {
    super();

    const serviceBlocks = document.querySelectorAll('[data-services-id]');

    serviceBlocks.forEach(blk => {
      this.appendNavItem(blk);
    });
  }

  appendNavItem(blk) {
    const servicesUL = this.querySelector('.services-navigation ul');
    const newLinkText = document.createTextNode(
      blk.getAttribute('data-services-id')
    );

    const newLink = document.createElement('a');
    const newLi = document.createElement('li');

    newLink.href = '#' + blk.id;
    newLink.classList.add('button', 'button--textlink', 'uppercase');
    newLink.appendChild(newLinkText);

    newLi.appendChild(newLink);

    servicesUL.appendChild(newLi);
  }
}

customElements.define('services-mobile-nav', servicesNav);

class localPhoneNumber extends HTMLElement {
  constructor() {
    super();
    this.numberArray = JSON.parse(
      document.getElementById('phoneNumbers').textContent
    );
    this.anchorLink = this.querySelector('a');
    this.localiseNumber = this.querySelectorAll('span.phone');
    this.localiseDetails = this.querySelectorAll('span.details');

    this.getLocale();
  }

  async fetchUserJSON() {
    let response = await fetch(`/browsing_context_suggestions.json`);
    let data = await response.json();
    return data.detected_values;
  }

  async getLocale() {
    // Check if local storage country exists
    const localObj = localStorage.getItem('userCountry');
    let checkingUserLocale = '';
    if (!localObj) {
      checkingUserLocale = null;
    } else {
      const item = JSON.parse(localObj);
      if (new Date() > new Date(item.expiry)) {
        localStorage.removeItem('userCountry');
        checkingUserLocale = null;
      } else {
        checkingUserLocale = item.value;
      }
    }
    if (!checkingUserLocale) {
      // No local storage country already exists so fetch data
      this.fetchUserJSON().then(userData => {
        if (userData) {
          // Set local storage for next time (with 24h expiry)
          let ttl = new Date();
          ttl.setHours(ttl.getHours() + 24);
          localStorage.setItem(
            'userCountry',
            JSON.stringify({ value: userData.country.handle, expiry: ttl })
          );
          this.returnFunction(userData.country.handle);
        }
      });
    } else {
      this.returnFunction(checkingUserLocale);
    }
  }

  returnFunction(userLocale) {
    const defaultNumber = this.numberArray.find(
      locale => locale.country === 'default'
    ).phone;
    const defaultDetails = this.numberArray.find(
      locale => locale.country === 'default'
    ).details;

    let localNumber = null;
    let localDetails = null;

    this.numberArray.forEach(locale => {
      if (locale.country == userLocale) {
        localNumber = locale.phone;
        localDetails = locale.details;
        return;
      }
    });

    if (this.anchorLink) {
      this.populateAnchorHref(localNumber ? localNumber : defaultNumber);
    }

    if (this.localiseNumber.length > 0) {
      this.populateNumbers(localNumber ? localNumber : defaultNumber);
    }

    if (this.localiseDetails.length > 0) {
      this.populateDetails(localDetails ? localDetails : defaultDetails);
    }
  }

  populateAnchorHref(newNumber) {
    const strippedNumber = newNumber
      .replace(/ /g, '')
      .replace(/\(/g, '')
      .replace(/\)/g, '');
    this.anchorLink.href = 'tel:' + strippedNumber;
  }

  populateNumbers(newNumber) {
    this.localiseNumber.forEach(span => {
      span.innerHTML = newNumber;
    });
  }

  populateDetails(newDetails) {
    this.localiseDetails.forEach(span => {
      span.innerHTML = newDetails;
    });
  }
}
customElements.define('localise-phone', localPhoneNumber);

{
  /* <button class="button button--textlink uppercase" data-filter-control="china-mainland">China Mainland</button> */
}

// ------------- Faq scrolling redirection for URL IDs of questions
if (document.querySelector('body').classList.contains('template-page.faqs')) {
  faqUrlWrapper();
}

function faqUrlWrapper() {
  let faqWrapperTarget = document.querySelector('.faq-page-wrapper');
  let faqQaParentBlocks = document.getElementsByClassName(
    'faq-questions-parent-blocks'
  );
  let faqQaBlocks = document.getElementsByClassName('faq-questions-blocks');
  let faqShopifySections =
    faqWrapperTarget.getElementsByClassName('shopify-section');
  let faqResultQaBlockId;

  for (let i = 0; i < faqQaBlocks.length; i++) {
    faqResultQaBlockId = faqQaBlocks[i].getAttribute('data-question-id');

    // check if QA ID matches in the browser and scroll to it on redirect
    if (
      faqResultQaBlockId != '' &&
      window.location.href.indexOf(faqResultQaBlockId) > -1
    ) {
      for (let j = 0; j < faqShopifySections.length; j++) {
        faqShopifySections[j].classList.add('hide');
      }

      faqWrapperTarget.classList.add('topic-view');
      faqWrapperTarget.classList.remove('landing-view');
      faqQaBlocks[i].closest('.shopify-section').classList.remove('hide');

      if (faqQaBlocks[i].getAttribute('faq-url-question') === 'question') {
        //if it's the QA's ID parent then set QA open
        for (let k = 0; k < faqQaParentBlocks.length; k++) {
          if (
            faqQaParentBlocks[k].getAttribute('data-question-id') ==
            faqQaBlocks[i].getAttribute('data-question-id')
          ) {
            faqQaParentBlocks[k].setAttribute('open', '');
          }
        }

        document.location.href = '#';
        document.location.href = '#' + faqResultQaBlockId + '?';

        window.scrollTo({
          top: faqResultQaBlockId
        });
      } else if (
        faqQaBlocks[i].getAttribute('faq-url-question') === 'heading'
      ) {
        document.location.href = '#';
        document.location.href = '#' + faqResultQaBlockId;

        window.scrollTo({
          top: faqResultQaBlockId
        });
      }
    }
  }

  // Faq URL triggers
  for (let l = 0; l < faqQaBlocks.length; l++) {
    faqQaBlocks[l].addEventListener('click', function (urlClicked) {
      faqUrlTriggers(urlClicked);
    });
  }

  function faqUrlTriggers(urlClicked) {
    for (let l = 0; l < faqQaBlocks.length; l++) {
      // Set ID of element as URL
      if (urlClicked.target.hasAttribute('data-question-id')) {
        let targetAttr = urlClicked.target.getAttribute('data-question-id');

        if (targetAttr == faqQaBlocks[l].getAttribute('data-question-id')) {
          document.location.replace('#' + targetAttr);
        }
      }
    }
  }
  // Faq URL triggers END
}
// ------------- Faq scrolling redirection for URL IDs of questions END

// --------- Swiper js Slider initialize
// Blog post v1 Assymetrical slider
if (document.querySelector('body').classList.contains('article-template')) {
  const swiperBlogv1AssymSlider = new Swiper('.swiper-blog-v1-assym-slider', {
    // Optional parameters
    direction: 'horizontal',
    loop: true,
    slidesPerView: 'auto',
    // Navigation arrows
    navigation: {
      nextEl: '.swiper__buttons--assym .swiper-button-next',
      prevEl: '.swiper__buttons--assym .swiper-button-prev'
    }
  });
  console.log(swiperBlogv1AssymSlider);
  console.log(swiperBlogv1AssymSlider.navigation);
}

// GeoIP Country Shipping
/* document.addEventListener("DOMContentLoaded", function() {
  let callCount = 1;
  let repeatCall = setInterval(function () {
    if (callCount < 20) {
      if (document.querySelector('.recommendation-modal__container')) {
        const glbe_geo = sessionStorage.getItem("GLBE_geo");
        const countryPopupHeader = window.countryPopupHeader;
        const countryPopupFirst = window.countryPopupFirst;
        const countryPopupSecond = window.countryPopupSecond;
        const noFeeCountries = window.noFeeCountries.split(',');
        const TaxesCountries = window.TaxesCountries.split(',');
        const DutiesAndTaxesCountires = window.DutiesAndTaxesCountires.split(',');
        const countryPopupContinue = window.countryPopupContinue;
        const countryPopupChange = window.countryPopupChange;

        let countryFound = document.createElement('span');
        let newH2 = document.createElement('h2');

        countryFound.classList.add('recommendation-modal__message--bold');
        if (document.querySelector('.recommendation-modal__message--bold').innerHTML == 'français') {
          countryFound.innerHTML = "france"
        } else {
          countryFound.innerHTML = document.querySelector('.recommendation-modal__message--bold').innerHTML;
        }

        newH2.classList.add('recommendation-modal__message');
        newH2.innerHTML = countryPopupHeader;
        newH2.appendChild(countryFound);
        document.querySelector('.recommendation-modal__message').parentNode.replaceChild(newH2, document.querySelector('.recommendation-modal__message'));

        if (document.querySelector('.recommendation-modal__benefits ul')) {
          document.querySelector('.recommendation-modal__benefits ul').innerHTML = '';
        } else {
          let newUlParent = document.createElement('div');
          newUlParent.classList.add('recommendation-modal__benefits');
          newUlParent.innerHTML = '<ul></ul>';
          document.querySelector('.recommendation-modal__message').after(newUlParent);
        }

        let newLi1 = document.createElement('li');
        newLi1.innerHTML = countryPopupFirst;
        document.querySelector('.recommendation-modal__benefits ul').appendChild(newLi1);

        let newLi2 = document.createElement('li');
        newLi2.innerHTML = countryPopupSecond;
        document.querySelector('.recommendation-modal__benefits ul').appendChild(newLi2);

        let addLiItem = "";
        if (noFeeCountries.includes(glbe_geo)) {
          addLiItem = window.noFeeMessage;
        } else if (TaxesCountries.includes(glbe_geo)) {
          addLiItem = window.TaxesMessage;
        } else if (DutiesAndTaxesCountires.includes(glbe_geo)) {
          addLiItem = window.DutiesAndTaxesMessage;
        }

        if (addLiItem !== "") {
          let newLi3 = document.createElement('li');
          newLi3.innerHTML = addLiItem;
          document.querySelector('.recommendation-modal__benefits ul').appendChild(newLi3);
        }

        document.querySelector('.recommendation-modal__button').innerHTML = countryPopupContinue;
        document.querySelector('.recommendation-modal__button--minimal').innerHTML = countryPopupChange;

        callCount = 20;
      } else {
        callCount += 1;
      }
    } else {
      clearInterval(repeatCall);
    }
  }, 300);
}); */

// Blog post v1 Normal slider
if (document.querySelector('body').classList.contains('article-template')) {
  const swiperBlogv1NormalSlider = new Swiper('.swiper-blog-v1-normal-slider', {
    // Optional parameters
    direction: 'horizontal',
    loop: true,
    slidesPerView: 'auto',
    // Navigation arrows
    navigation: {
      nextEl: '.swiper-button-next.swiper-button--normal',
      prevEl: '.swiper-button-prev.swiper-button--normal'
    }
  });
  console.log(swiperBlogv1NormalSlider);
  console.log(swiperBlogv1NormalSlider.navigation);
}

// Blog post v1 Posts feed slider
if (document.querySelector('body').classList.contains('article-template')) {
  const swiperBlogv1FeedSlider = new Swiper('.swiper-blog-v1-feed-slider', {
    // Optional parameters
    direction: 'horizontal',
    loop: true,
    slidesPerView: 'auto',
    // Navigation arrows
    navigation: {
      nextEl: 'swiper__buttons--feed .swiper-button-next',
      prevEl: 'swiper__buttons--feed .swiper-button-prev'
    }
  });
}

class MobileCountrySwitch extends HTMLElement {
  constructor() {
    super();
    this.triggerIn = this.querySelector('.mobile-country-call button');
    this.triggerOut = this.querySelector(
      '.mobile-country-content button.close-picker'
    );
    this.content = this.querySelector('.mobile-country-content');

    this.triggerIn.addEventListener('click', e => this.slideMobilePickerIn(e));
    this.triggerOut.addEventListener('click', e =>
      this.slideMobilePickerOut(e)
    );
  }

  slideMobilePickerIn(event) {
    event.preventDefault();
    this.content.classList.add('slide-in');
    document.querySelector(
      'offcanvas-menu#mobile-menu .offcanvas__close'
    ).style.display = 'none';
  }

  slideMobilePickerOut(event) {
    event.preventDefault();
    this.content.classList.remove('slide-in');
    document.querySelector(
      'offcanvas-menu#mobile-menu .offcanvas__close'
    ).style.display = '';
  }
}
customElements.define('mobile-country-switch', MobileCountrySwitch);

const largeVideoPlayerContainer = document.querySelectorAll(
  '[data-large-video-player-container]'
);
const allVideos = document.querySelectorAll('[data-large-video-player]');

largeVideoPlayerContainer.forEach(element => {
  const largeVideoPlayer = element.querySelector('[data-large-video-player]');
  const largeVideoPlayerCount = element.querySelectorAll(
    '[data-large-video-player]'
  ).length;
  const largeVideoPlayerMuteToggleBtn = element.querySelector(
    '[data-large-video-mute-toggle]'
  );
  if (largeVideoPlayerMuteToggleBtn) {
    largeVideoPlayerMuteToggleBtn.addEventListener('click', event => {
      const parentEl = largeVideoPlayer.parentElement;
      const parentContr = largeVideoPlayer.closest(
        '[data-large-video-player-container]'
      );

      if (parentEl && parentEl.classList.contains('keen-slider__slide')) {
        const idOfSlide = parentEl.getAttribute('id');
        var mobilevideoPlayer = parentEl.querySelector(
          '#' + idOfSlide + ' #mobileVideo'
        );
        var desktopvideoPlayer = parentEl.querySelector(
          '#' + idOfSlide + ' #desktopVideo'
        );
        var videoPlayer;

        if (mobilevideoPlayer.offsetParent) {
          videoPlayer = mobilevideoPlayer;
        }

        if (desktopvideoPlayer.offsetParent) {
          videoPlayer = desktopvideoPlayer;
        }
      } else if (largeVideoPlayerCount > 1) {
        var mobilevideoPlayer = parentEl.querySelector('#mobileVideo');
        var desktopvideoPlayer = parentEl.querySelector('#desktopVideo');
        var videoPlayer;

        if (mobilevideoPlayer.offsetParent) {
          videoPlayer = mobilevideoPlayer;
        }

        if (desktopvideoPlayer.offsetParent) {
          videoPlayer = desktopvideoPlayer;
        }
      } else {
        var videoPlayer = parentEl.querySelector('[data-large-video-player]');
      }

      const videoPlayerMuteSVG = parentContr.querySelector(
        '.featured-grid-media--mute-btn-muted'
      );
      const videoPlayerUnMuteSVG = parentContr.querySelector(
        '.featured-grid-media--mute-btn-unmuted'
      );
      const allVideoPlayerMuteSVG = document.querySelectorAll(
        '.featured-grid-media--mute-btn-muted'
      );
      const allVideoPlayerUnMuteSVG = document.querySelectorAll(
        '.featured-grid-media--mute-btn-unmuted'
      );

      if (videoPlayer.muted == true) {
        allVideos.forEach(element => {
          element.muted = true;
        });

        allVideoPlayerUnMuteSVG.forEach(element => {
          element.style.display = 'none';
        });

        allVideoPlayerMuteSVG.forEach(element => {
          element.style.display = 'block';
        });

        videoPlayer.muted = false;
        videoPlayerUnMuteSVG.style.display = 'block';
        videoPlayerMuteSVG.style.display = 'none';
      } else {
        allVideos.forEach(element => {
          element.muted = true;
        });

        allVideoPlayerUnMuteSVG.forEach(element => {
          element.style.display = 'none';
        });

        allVideoPlayerMuteSVG.forEach(element => {
          element.style.display = 'block';
        });

        videoPlayer.muted = true;
        videoPlayerUnMuteSVG.style.display = 'none';
        videoPlayerMuteSVG.style.display = 'block';
      }
    });
  }
});

class personaliseModal extends HTMLElement {
  constructor() {
    super();

    this.productSku = document
      .getElementById('configure-moynat')
      .getAttribute('data-sku');
    this.is3dPersonalisation = this.getAttribute('data-personalisation-3d');
    this.variantSkuMap = JSON.parse(
      document.getElementById('variantSkuMap').textContent
    );
    this.currentSavedCookie = '';

    this.addToCartCTA = this.querySelector('.personalisation__cart-cta');
    this.editCTA = this.querySelector('.personalisation__edit-cta');
    this.clearCTA = this.querySelector('.personalisation__clear-cta');
    this.clearCTAconfirmed = this.querySelector(
      '.personalisation__clear-cta-confirmed'
    );
    this.closeCTAconfirm = this.querySelector(
      '.personalisation__active-recipe-confirm-close'
    );

    this.addToCartCTA.addEventListener(
      'click',
      this.addRecipeToCart.bind(this)
    );
    this.editCTA.addEventListener('click', this.editRecipe.bind(this));
    this.clearCTA.addEventListener('click', this.confirmClear.bind(this));
    this.clearCTAconfirmed.addEventListener(
      'click',
      this.clearRecipe.bind(this)
    );
    this.closeCTAconfirm.addEventListener(
      'click',
      this.confirmClose.bind(this)
    );

    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    let fallBack = false;

    if (urlParams.has('recipe')) {
      const recipeID = urlParams.get('recipe');
      if (recipeID !== '') {
        fetch(
          `https://prod.fluidconfigure.com/api/recipe/${recipeID}?api-key=M07NAT-3E2T0m-PR0830L7J8`
        )
          .then(response => response.text())
          .then(responseText => {
            const responseJSON = JSON.parse(responseText);
            console.dir(responseJSON);
            if (responseJSON.error) {
              fallBack = true;
            } else {
              const returnSku = responseJSON.custom.sku;
              if (this.variantSkuMap.find(map => map.sku === returnSku)) {
                this.newRecipe(recipeID, returnSku);
              } else {
                fallBack = true;
              }
            }
          });
      } else {
        fallBack = true;
      }
    } else {
      fallBack = true;
    }
    if (fallBack) this.checkForRecipe();
  }

  variantChange() {
    const notifyButton = document.querySelector('button.fostr-bis-register');
    notifyButton.classList.add('hidden');
    this.checkForRecipe();
  }

  checkForRecipe() {
    console.log('function - check for recipe');
    this.productSku = document
      .getElementById('configure-moynat')
      .getAttribute('data-sku');
    this.currentSavedCookie = localStorage.getItem('productRecipes');
    if (this.currentSavedCookie) {
      const productRecipes = JSON.parse(this.currentSavedCookie);
      if (productRecipes.hasOwnProperty(this.productSku)) {
        if (new Date() > new Date(productRecipes[this.productSku].expiry)) {
          delete productRecipes[this.productSku];
          localStorage.setItem(
            'productRecipes',
            JSON.stringify(productRecipes)
          );
          this.noRecipeActive();
        } else {
          this.recipeActive(productRecipes[this.productSku].recipeID);
        }
      } else {
        this.noRecipeActive();
      }
    } else {
      this.noRecipeActive();
    }
  }

  newRecipe(recipeID, recipeSku) {
    console.log('function - new recipe');
    let skuDiff = false;
    if (this.productSku != recipeSku) {
      this.productSku = recipeSku;
      skuDiff = true;
    }
    if (this.currentSavedCookie) {
      const productRecipes = JSON.parse(this.currentSavedCookie);
      if (productRecipes.hasOwnProperty(recipeSku)) {
        delete productRecipes[recipeSku];
        localStorage.setItem('productRecipes', JSON.stringify(productRecipes));
      }
    }

    let ttl = new Date();
    ttl.setMonth(ttl.getMonth() + 6);

    let newRecipe = {
      recipeID: recipeID,
      expiry: ttl
    };

    if (this.currentSavedCookie) {
      let newCookie = JSON.parse(this.currentSavedCookie);
      newCookie[recipeSku] = newRecipe;
      localStorage.setItem('productRecipes', JSON.stringify(newCookie));
    } else {
      localStorage.setItem(
        'productRecipes',
        JSON.stringify({ [this.productSku]: newRecipe })
      );
    }

    if (skuDiff) {
      const newColour = this.variantSkuMap.find(
        map => map.sku === recipeSku
      ).title;
      const colourSwatches = document.querySelectorAll('input[name="Color"]');
      colourSwatches.forEach(swatch => {
        if (swatch.value == newColour) {
          swatch.click();
        }
      });
    } else {
      this.checkForRecipe();
    }
  }

  recipeActive(activeRecipe) {
    console.log('function - recipe active');
    const lang = document
      .querySelector('#configure-moynat')
      .getAttribute('data-lang');
    const varID = this.variantSkuMap.find(
      map => map.sku === this.productSku
    ).varID;

    let callLocale = '';
    switch (lang) {
      case 'en':
        callLocale = 'en_UK';
        break;
      case 'zh-CN':
        callLocale = 'zh_CN';
        break;
      default:
        callLocale = 'fr_FR';
    }

    this.editCTA.setAttribute('data-active-recipe', activeRecipe);
    document
      .getElementById('configure-moynat')
      .setAttribute('data-recipe-override', activeRecipe);

    const siteLang = document.querySelector('html').getAttribute('lang');
    document.querySelector('.product-form-buy-buttons').style.display = 'none';

    fetch(
      `https://prod.fluidconfigure.com/api/recipe/${activeRecipe}?api-key=M07NAT-3E2T0m-PR0830L7J8&locale=${callLocale}&include=localized_configuration`
    )
      .then(response => response.text())
      .then(responseText => {
        const responseJSON = JSON.parse(responseText);
        console.dir(responseJSON);

        const attList = document.querySelector('.customised-attributes__list');
        const atcBtn = document.querySelector('.personalisation__cart-cta');
        const isPurchasable = responseJSON.custom['purchasable'];
        const atcContr = this.querySelector('add-to-cart-button');
        const unpurchasableButton = this.querySelector(
          '.personalisation__unpurchasable'
        );
        const customisedType =
          responseJSON.localized_configuration['personalization'];
        const initialsLocation =
          responseJSON.localized_configuration['initials_location'];
        const initialsSide =
          responseJSON.localized_configuration['initials_side'];
        const noPersonalisationLabel = attList.getAttribute(
          'data-no-personalisation'
        );
        const monogramLabel = attList.getAttribute('data-monogram');
        const handpaintingLabel = attList.getAttribute('data-handpainting');
        let showFront = false;

        attList.innerHTML = '';

        let newLi = document.createElement('li');
        if (customisedType == 'None') {
          newLi.innerHTML =
            '<p><span>' + noPersonalisationLabel + '</span></p>';
        } else if (
          customisedType == 'Initials Only' ||
          customisedType == 'Initiales' ||
          customisedType == '仅字母'
        ) {
          newLi.innerHTML =
            '<p><span>' +
            monogramLabel +
            '</span> : ' +
            responseJSON.localized_configuration['initials_derived'] +
            '</p>';
        } else if (
          customisedType == 'Ribbon and Initials' ||
          customisedType == 'Ribbons and Initials' ||
          customisedType == 'Ruban et Initiales' ||
          customisedType == '条纹和字母'
        ) {
          newLi.innerHTML =
            '<p><span>' +
            handpaintingLabel +
            '</span> : ' +
            responseJSON.localized_configuration['initials_derived'] +
            '</p>';
        }
        attList.appendChild(newLi);

        let atcAttributes = {};
        atcAttributes['Customized'] = 'true';
        atcAttributes['Recipe_id'] = activeRecipe.toString();

        if (this.is3dPersonalisation) {
          atcAttributes['Initial Placement'] = '3D Front';
        } else if (
          initialsLocation == 'Front' ||
          initialsLocation == 'Face' ||
          initialsLocation == '正面' ||
          initialsSide == 'Front' ||
          initialsSide == 'Face' ||
          initialsSide == '正面'
        ) {
          showFront = true;
          atcAttributes['Initial Placement'] = 'Front';
        }

        if (this.getAttribute('data-personalisation-type') == 'Monogramming') {
          atcAttributes['Delivery note'] = this.getAttribute(
            'data-monogramming-note'
          );
        } else if (
          this.getAttribute('data-personalisation-type') == 'Handpainting'
        ) {
          atcAttributes['Delivery note'] = this.getAttribute(
            'data-handpainting-note'
          );
        }

        if (this.is3dPersonalisation) {
          document.querySelector(
            '.personalisation__active-recipe-image img'
          ).src =
            `https://cdn-webgl-ssr-prod.fluidconfigure.com/snapshot/recipe/${activeRecipe}/image/Front.png`;
        } else if (showFront) {
          document.querySelector(
            '.personalisation__active-recipe-image img'
          ).src =
            `https://prod.fluidconfigure.com/imagecomposer/recipe/${activeRecipe}/image/Front,1.png`;
        } else {
          document.querySelector(
            '.personalisation__active-recipe-image img'
          ).src =
            `https://prod.fluidconfigure.com/imagecomposer/recipe/${activeRecipe}/image/Back,1.png`;
        }

        atcBtn.parentNode.setAttribute('variant-ids', varID);
        atcBtn.parentNode.setAttribute(
          'line-item-props',
          JSON.stringify(atcAttributes)
        );

        if (
          document.querySelector(
            '.product-form-buy-buttons .product-form__submit'
          ).disabled
        ) {
          atcBtn.classList.add('hidden');
        } else {
          atcBtn.classList.remove('hidden');
        }

        if (isPurchasable) {
          atcContr.classList.remove('hidden');
          unpurchasableButton.classList.add('hidden');
        } else {
          atcContr.classList.add('hidden');
          unpurchasableButton.classList.remove('hidden');
        }

        if (this.is3dPersonalisation) {
          console.log('3d product');
          console.log(CID);
        } else {
          console.log('not 3d product');
          document.getElementById('configure-moynat').innerHTML = '';
          window.populateCreateMe();
        }
      });

    this.querySelector('.personalisation__customise-cta').style.display =
      'none';
    this.querySelector(
      '.personalisation__return_delivery_message.before-customisation'
    ).style.display = 'none';
    this.querySelector('.personalisation__active-recipe').style.display = '';
    this.querySelector('.personalisation__active-recipe').classList.add(
      'visible'
    );

    if (
      document.querySelector('.product-form-buy-buttons .product-form__submit')
        .disabled
    ) {
      document.querySelector('.product-form-buy-buttons').style.display = '';
    }
  }

  noRecipeActive() {
    console.log('function - no recipe active');
    document
      .getElementById('configure-moynat')
      .setAttribute('data-recipe-override', '');
    if (!this.is3dPersonalisation) {
      document.getElementById('configure-moynat').innerHTML = '';
      const funcStatus = typeof window.populateCreateMe;
      if (funcStatus != 'undefined') {
        console.log('call function');
        window.populateCreateMe();
      }
    }

    this.querySelector('.personalisation__customise-cta').style.display = '';
    this.querySelector(
      '.personalisation__return_delivery_message.before-customisation'
    ).style.display = '';
    this.querySelector('.personalisation__active-recipe').style.display =
      'none';
    this.querySelector('.personalisation__active-recipe').classList.remove(
      'visible'
    );
    document.querySelector('.product-form-buy-buttons').style.display = '';
  }

  addRecipeToCart() {
    console.log('function - add recipe to cart');
    const productRecipes = JSON.parse(this.currentSavedCookie);
    delete productRecipes[this.productSku];
    localStorage.setItem('productRecipes', JSON.stringify(productRecipes));

    this.checkForRecipe();
  }

  editRecipe() {}

  confirmClear() {
    console.log('function - confirm clear');
    const confirmBlock = this.querySelector(
      '.personalisation__active-recipe-confirm-remove'
    );
    confirmBlock.classList.remove('hide-block');
  }

  confirmClose() {
    console.log('function - confirm close');
    const confirmBlock = this.querySelector(
      '.personalisation__active-recipe-confirm-remove'
    );
    confirmBlock.classList.add('hide-block');
  }

  clearRecipe() {
    console.log('function - clear recipe');
    const productRecipes = JSON.parse(this.currentSavedCookie);
    delete productRecipes[this.productSku];
    localStorage.setItem('productRecipes', JSON.stringify(productRecipes));
    if (this.is3dPersonalisation) {
      console.log('clear 3d recipe');
      CID.removeRecipe();
    } else {
      console.log('reboot for 2d');
      document.getElementById('configure-moynat').innerHTML = '';
      window.populateCreateMe();
    }
    this.noRecipeActive();
    this.querySelector(
      '.personalisation__active-recipe-confirm-remove'
    ).classList.add('hide-block');
  }
}
customElements.define('personalisation-modal', personaliseModal);

document
  .getElementById('SearchToggleDesktop')
  .addEventListener('click', function () {
    document.querySelector('html').classList.add('overflow-y-hidden');
    setTimeout(function () {
      document.getElementById('Search-In-Modal').focus();
    }, 100);
    document
      .querySelector('.offcanvas-dimmer')
      .classList.add('body-overflow-y-hidden');
    document
      .querySelector('.offcanvas-dimmer.body-overflow-y-hidden')
      .addEventListener('click', removePageLock);
  });

function removePageLock() {
  document
    .querySelector('.offcanvas-dimmer.body-overflow-y-hidden')
    .removeEventListener('click', removePageLock);
  document.querySelector('html').classList.remove('overflow-y-hidden');
  document
    .querySelector('.offcanvas-dimmer')
    .classList.remove('body-overflow-y-hidden');
}

document.querySelector('.search-close')?.addEventListener('click', function () {
  document.querySelector('html').classList.remove('overflow-y-hidden');
});

window.addEventListener('resize', event => {
  if (
    document.querySelector('#search-sidebar').classList.contains('is-active')
  ) {
    if (window.innerWidth < 1250) {
      document.querySelector('#search-sidebar').style.height =
        window.innerHeight + 'px';
    } else {
      document.querySelector('#search-sidebar').style.height = 'auto';
    }
  }
});

class fostrBisModal extends HTMLElement {
  constructor() {
    super();
    this.registerButton = this.querySelector('.fostr-bis-register');
    this.closeButton = this.querySelector('button.close');
    this.submitButton = this.querySelector('button.fostr-bis-register-submit');

    this.prodId = this.closest('[data-prodid]').getAttribute('data-prodid');
    this.varId = this.closest('[data-varid]').getAttribute('data-varid');

    this.registerButton.addEventListener('click', e => this.openBisForm(e));
    this.closeButton.addEventListener('click', e => this.closeBisForm(e));
    this.submitButton.addEventListener('click', e => this.submitBisForm(e));
  }

  openBisForm(e) {
    e.preventDefault();
    this.querySelector('#bis-container').style.display = 'flex';
    this.varId = this.closest('[data-varid]').getAttribute('data-varid');

    const emailInput = document.querySelector('#klaviyo-custom-bis-email');
    emailInput.addEventListener('change', event => {
      if (emailInput.value.length > 0) {
        if (emailInput.nextElementSibling)
          emailInput.nextElementSibling.classList.add('input-filled');
      } else {
        if (emailInput.nextElementSibling)
          emailInput.nextElementSibling.classList.remove('input-filled');
      }
    });
  }

  closeBisForm(e) {
    e.preventDefault();
    this.querySelector('#bis-container').style.display = 'none';
  }

  submitBisForm(e) {
    e.preventDefault();
    this.querySelector('.error_message').style.display = 'none';
    const emailField = this.querySelector('#klaviyo-custom-bis-email');
    const userLocale = this.getAttribute('data-user-locale');
    const url =
      'https://a.klaviyo.com/onsite/components/back-in-stock/subscribe';
    const xhr = new XMLHttpRequest();
    const data = `a=RCqFbp&email=${encodeURIComponent(emailField.value)}&variant=${this.varId}&product=${this.prodId}&platform=shopify`;

    if (emailField.value.length > 0 && emailField.validity.valid) {
      this.querySelector('.error_message').style.display = 'none';

      xhr.open('POST', url);
      xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
      xhr.onreadystatechange = function () {
        if (xhr.readyState === 4) {
          console.log(xhr.status);
          console.log(xhr.responseText);
        }
      };
      xhr.send(data);

      this.submitLang(emailField.value, userLocale);
    } else {
      this.querySelector('.error_message').style.display = 'block';
    }
  }

  submitLang(userEmail, userLocale) {
    const langPayload = {
      method: 'POST',
      headers: {
        accept: 'application/json',
        revision: '2023-09-15',
        'content-type': 'application/json'
      },
      body: JSON.stringify({
        data: {
          type: 'profile',
          attributes: {
            email: userEmail,
            properties: { language: userLocale }
          },
          meta: {
            patch_properties: { append: { language: userLocale } }
          }
        }
      })
    };

    fetch(
      'https://a.klaviyo.com/client/profiles/?company_id=RCqFbp',
      langPayload
    )
      .then(response => response.status)
      .then(result => console.log(result))
      .catch(err => console.error(err));

    this.querySelector('button.fostr-bis-register-submit').disabled = true;
    this.querySelector('.completed_message').style.display = 'block';
  }
}
customElements.define('fostr-bis-modal', fostrBisModal);
